
import RefundSettingsTable from "../../components/Settings/RefundSettingsTable";

const SettingPage = () => {
  return <RefundSettingsTable />;
};

export default SettingPage;
